<template>
<div id="screen">
    <p>{{screen.msg}}</p>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['screen', 'islandscape'])
  },
  mounted() {
    this.isLandscape()
  },
  methods: {
    isLandscape () {
      // 初始化进来是竖屏状态
      let data = {isLandscape: this.islandscape}
      let orientationChange = (params) => {
        switch (window.orientation) {
          case 0:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }
            break;
          case -90:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }

            break;
          case 90:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }
            break;
          case 180:
            // 当前是竖屏
            if (screen.width < screen.height) {
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              }
            } else {
              // 当前是横屏
              if (params.isLandscape === true) {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', '')
              } else {
                this.$store.dispatch('SET_SDK_COMPONENT_SCREEN', {name: 'screenc', msg: '请竖屏体验效果更佳'})
              }
            }
            break;
        }
      }
      window.addEventListener('orientationchange', function() {
        orientationChange(data)
        window.onorientationchange = orientationChange(data)
      })
      orientationChange(data)
    }
  }
}
</script>

<style lang="scss" scoped>
#screen{
    width:100%;
    height:100%;
    background:rgba(0,0,0,.5);
    color:#fff;
    position: fixed;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:.8rem;
}
</style>
